import { SettingsPage } from "@/features/settings/SettingsPage";
import { useAppShell } from "@/shell/app-shell-context";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";

export function SettingsRoute() {
  const { token } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;

  return (
    <SettingsPage
      companyId={company.id}
      companyName={company.name}
      token={token}
    />
  );
}
